import { useQuery, type UseQueryOptions, type QueryKey } from '@tanstack/react-query';
import { useAuthStore } from '../../app/store/auth-store';

// A thin wrapper over useQuery that disables fetching when user is not authenticated
// and turns off auto refetch behaviors while unauthenticated.
export function useProtectedQuery<TQueryFnData, TError = unknown, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
) {
  const { isAuthenticated } = useAuthStore();

  // Merge caller-provided options with auth-aware defaults
  const mergedOptions: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey> = {
    ...options,
    enabled: (options.enabled ?? true) && isAuthenticated,
    refetchOnWindowFocus: isAuthenticated ? (options.refetchOnWindowFocus ?? 'always') : false,
    refetchOnReconnect: isAuthenticated ? (options.refetchOnReconnect ?? 'always') : false,
    // Keep user's staleTime/gcTime/retry, don't override unless necessary
  };

  return useQuery(mergedOptions);
}


